import SectionComment from './SectionComment';

export default SectionComment;
